import React, { useCallback } from 'react';
import PopoverContainer from '../../_partials/PopoverContainer';
import PopperPositionedPopover from '../../PopperPositionedPopover';
const PositionOnlyPopperPopover = /*#__PURE__*/ React.forwardRef(({ isVisible = true, usePortal = true, placement, secondaryPlacement, referenceElement, width, height, offsetModifier, allowFlip, eventsEnabled, positionFixed, children, role, 'aria-label': ariaLabel, className, wrapperClassName, contentClassName, directionalClassNames, popoverContent, innerRef, onClickOutside, onMouseEnter, onMouseLeave, onKeyDown, onReferenceClick, renderReference }, ref)=>{
    const renderPopover = useCallback(({ effectivePlacement, rootRef, contentStyle, contentAttributes, updatePositioning })=>/*#__PURE__*/ React.createElement(PopoverContainer, {
            ref: rootRef,
            innerRef: innerRef,
            placement: effectivePlacement,
            style: contentStyle,
            attributes: contentAttributes,
            wrapperClassName: wrapperClassName,
            contentClassName: contentClassName,
            directionalClassNames: directionalClassNames,
            width: width,
            height: height,
            updatePositioning: updatePositioning,
            onClickOutside: onClickOutside,
            role: role,
            "aria-label": ariaLabel,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: onKeyDown
        }, typeof popoverContent === 'function' ? popoverContent({
            placement: effectivePlacement,
            updatePositioning
        }) : popoverContent), [
        innerRef,
        wrapperClassName,
        contentClassName,
        directionalClassNames,
        role,
        ariaLabel,
        onMouseEnter,
        onMouseLeave,
        onKeyDown,
        onClickOutside,
        width,
        height,
        popoverContent
    ]);
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        ref: ref,
        className: className,
        isVisible: isVisible,
        usePortal: usePortal,
        offsetModifier: offsetModifier,
        allowFlip: allowFlip,
        eventsEnabled: eventsEnabled,
        positionFixed: positionFixed,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        referenceElement: referenceElement,
        onReferenceClick: onReferenceClick,
        renderReference: renderReference,
        renderPopover: renderPopover
    }, children);
});
PositionOnlyPopperPopover.displayName = 'PositionOnlyPopperPopover';
export default PositionOnlyPopperPopover;
